import { defineComponent as _defineComponent } from 'vue'
import moment from "moment";
import { computed, onMounted, onUnmounted, ref } from "vue";
import {
  isLiveEventsSchedule,
  isServiceError,
  isServiceLoading,
  isServiceSuccess,
  LiveEventsScheduleDay,
  ServiceResult,
} from "@/data.types";
import { staticDataService } from "../main";


export default /*#__PURE__*/_defineComponent({
  __name: 'nasatv-schedule',
  setup(__props) {

let time_fmt = new Intl.DateTimeFormat("en-US", { timeStyle: "short" });
let day_fmt = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
  month: "long",
});
function tstext_fmt(date: Date) {
  return `${time_fmt.format(date)} on ${day_fmt.format(date)}`;
}
function dateFormat(date: Date, todayRef?: Date) {
  return day_fmt.format(todayRef || new Date()) == day_fmt.format(new Date(date))
    ? time_fmt.format(new Date(date))
    : tstext_fmt(new Date(date))
}
function date(d: string | Date) {
  return moment.utc(d).format("DD.MM.YYYY");
}
function time(d: string | Date) {
  return moment.utc(d).format("HH:mm z");
}

let data = ref<ServiceResult>({ error: new Error("No data yet.") });
let updateDataInterval = ref<number | null>(null);

function updateData() {
  data.value = { ...data.value, loading: true }
  staticDataService.getLiveEventsSchedule().then((newData) => {
    data.value = newData;
  })
}
onMounted(() => {
  updateDataInterval.value = setInterval(updateData, 5 * 60 * 1000);
  updateData();
});
onUnmounted(() => {
  if (updateDataInterval.value) clearInterval(updateDataInterval.value);
});


const lastRefresh = computed(() => {
  return isServiceSuccess(data.value) && isLiveEventsSchedule(data.value.data) ? dateFormat(data.value.data.timestamp) : "";
})
const lastUpdate = computed(() => {
  return isServiceSuccess(data.value) && isLiveEventsSchedule(data.value.data) ? dateFormat(data.value.data.effective) : "";

})

const schedule = computed<Array<LiveEventsScheduleDay> | string>(() => {
  let days: Array<LiveEventsScheduleDay> = [];
  if (isServiceSuccess(data.value)) {
    if (isLiveEventsSchedule(data.value.data)) {
      for (let i = 0; i < 3; i++) {
        const day = moment().add(i, "days").format("YYYY-MM-DD");
        const events = data.value.data.data.schedule
          .filter((entry) => moment(entry.time).format("YYYY-MM-DD") === day)
          .map((event) => ({
            ...event,
            content: event.content
              .replaceAll(
                /\[([^\]]*)\]\(([^\)]*)\)/g,
                (_match, text, href) =>
                  `<a href="${href}" target="_blank">${text}</a>`,
              )
              .replaceAll(
                /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/g,
                (match) =>
                  dateFormat(new Date(match), event.time),
              ) + " Stream on: " + Object.entries(event.streaming_services).map(([service, url]) => `<a target="_blank" href="${url}">${service}</a>`).join(", "),
          }));
        if (events.length > 0)
          days.push({
            day,
            events,
          });
      }

      if (days.length === 0) {
        return "No Live event scheduled in the next three days...";
      }
    } else {
      return "Invalid data";
    }
  } else if (isServiceLoading(data.value)) {
    return `Loading...`;
  } else if (isServiceError(data.value)) {
    return `Failed to load schedule: "${data.value.error.name}" - ${data.value.error.message}`;
  }

  return days;
});

return { __sfc: true,time_fmt, day_fmt, tstext_fmt, dateFormat, date, time, data, updateDataInterval, updateData, lastRefresh, lastUpdate, schedule, isServiceLoading }
}

})